import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
} from "ionic-angular";
import { Http } from "@angular/http";
import { ViewController } from "ionic-angular";
import config from "../../config/config";

/**
 * Generated class for the ModalLivroCaixaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-modal-livro-caixa',
  templateUrl: 'modal-livro-caixa.html',
})
export class ModalLivroCaixaPage {
  siape: any;
  grupo:any;
  pagamentos = [];
  collapse = false


  constructor(public navCtrl: NavController,
    private alertCtrl: AlertController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    private _http: Http) {
  }
  ionViewDidLoad() {
    this.siape = this.navParams.get("siape");
    this.grupo = this.navParams.get("grupo");

    this.getPagamentos()


  }
  getPagamentos() {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "lista/livroCaixa/" + this.siape, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.pagamentos = res;
        loading.dismiss();

      })
      .catch(error => {
        console.log(error);
        loading.dismiss();

      });
  }
  valorPago(pag) {
    console.log(this.grupo);
    if (!pag.em_dia && this.grupo === 2) {

      let alert = this.alertCtrl.create({
        title: 'Valor Recebido',
        inputs: [
          {
            name: 'Valor_recebido',
            placeholder: 'Valor Recebido',
            type: 'number'
          },

        ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: data => {
            }
          },
          {
            text: 'OK',
            handler: data => {
              data.id = pag.id
              this.enviarPagamento(data)
            }
          }
        ]
      });
      alert.present();
    }
  }
  enviarPagamento(data){
    this._http
      .post(config.urlAPI + "livrocaixa/pagUser",data, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
      this.getPagamentos()

      })
      .catch(error => {
        console.log(error);
        

      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/modal-livro-caixa/modal-livro-caixa.ts